import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo, useState } from 'react';
import { BlocklyWorkspace } from 'react-blockly';
import { generateToolbox, generateWorkspace } from './generators/workspace';
import { EffectiveThemeType } from '../theme/types';
import * as Blockly from 'blockly';
import { selectThemeType } from '../theme/selector';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import './scenario-editor.css';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Box } from '@mui/material';
import { getEffectiveThemeMode } from '../theme/styles/dark-theme';
import { useSkeleton } from 'console/shared/features/skeleton/hook';
function BlocklyPreviewImpl(props) {
    const { config, scenario } = props;
    const toolbox = useMemo(() => generateToolbox(config, scenario), [config, scenario]);
    const workspace = useMemo(() => generateWorkspace(config, scenario), [config, scenario]);
    const Skeleton = useSkeleton('blockly', true, 500);
    const user_theme_type = useAppSelector(selectThemeType);
    const theme_type = useMemo(() => getEffectiveThemeMode(user_theme_type), [user_theme_type]);
    const [increment, setIncrement] = useState(0);
    useEffect(() => {
        //Нужен для того, чтобы перерисовать превью, когда поменяем сценарий
        setIncrement(increment + 1);
    }, [scenario]);
    return (_jsx(ErrorBoundary, { children: _jsx(Box, { width: "100%", children: _jsx(Skeleton, { children: _jsx(BlocklyWorkspace, { className: "scenario-preview", workspaceConfiguration: {
                        // Blockly.Themes есть
                        theme: theme_type === EffectiveThemeType.DARK
                            ? //@ts-ignore
                                Blockly.Themes.Dark
                            : //@ts-ignore
                                Blockly.Themes.Classic,
                        readOnly: true,
                        toolbox,
                    }, initialXml: workspace }, increment) }) }) }));
}
export const BlocklyPreview = memo(BlocklyPreviewImpl);
